import { useEffect, useState } from 'react'
import { marked } from 'marked'
import { getSkillMarkdownPath } from './constants'

type SkillPageProps = {
  onBack: () => void
}

export function SkillPage({ onBack }: SkillPageProps) {
  const [html, setHtml] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const url = getSkillMarkdownPath()
    let cancelled = false
    void fetch(url)
      .then((r) => {
        if (!r.ok) throw new Error(`Failed to load ${url} (${r.status})`)
        return r.text()
      })
      .then((md) => {
        if (cancelled) return
        setHtml(marked.parse(md, { async: false }) as string)
      })
      .catch((e: unknown) => {
        if (!cancelled) setError(e instanceof Error ? e.message : 'Failed to load skill.md')
      })
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onBack}
          className="flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
          Back to app
        </button>
      </div>
      {error && (
        <p className="text-red-300 text-sm" role="alert">
          {error}
        </p>
      )}
      {!error && html === null && <p className="text-gray-400 text-sm">Loading guide…</p>}
      {html !== null && (
        <article
          className="skill-prose text-gray-300 text-sm leading-relaxed"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      )}
    </div>
  )
}
